import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-tone"]
const _hoisted_2 = { class: "snackbar-icon-wrap" }
const _hoisted_3 = { class: "snackbar-content-wrap" }
const _hoisted_4 = { class: "snackbar-title" }
const _hoisted_5 = { class: "snackbar-lines" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    "model-value": _ctx.modelValue,
    timeout: _ctx.timeout,
    location: "bottom",
    rounded: "pill",
    "min-width": "360",
    "content-class": "vsk-snackbar-content",
    class: "vsk-snackbar",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "snackbar-shell",
        "data-tone": _ctx.normalizedTone
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.icon), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                class: "snackbar-line"
              }, _toDisplayString(line), 1))
            }), 128))
          ])
        ]),
        _createVNode(_component_v_btn, {
          icon: "mdi-close",
          size: "x-small",
          variant: "text",
          class: "snackbar-close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        })
      ], 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["model-value", "timeout"]))
}